import { async } from '@firebase/util';
import axios from 'axios';
import { getUrl } from 'functions/BaseAxios';
import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const PageTermCondition = () => {
  const { t } = useTranslation();
  const [description, setdescription] = useState(null)
  useEffect(() => {
    getData();
  }, [])

  const getData = async () => {
    var config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        // 'Content-Type': 'application/json',
      }
    };
    const patname = window.location.pathname;
    let q = 'tc';
    if (patname === '/privacy-policy') {
      q = 'pp';
    } else if (patname === '/cancelation-policy') {
      q = 'cp'
    }

    await axios.get(`${getUrl('api/legal?q=' + q)}`)
      .then((dat) => {
        if (dat.data.payload) {
          setdescription(dat.data.payload.description);
        }
      })
  }

  return (
    <div className="nc-PageHome relative overflow-hidden">
      <Helmet>
        <title>{t('term_cond')}</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32 legal" style={{ minHeight: '50vh', paddingRight: 20, paddingLeft: 20 }}>
        <div style={{ overflowWrap: 'anywhere' }} dangerouslySetInnerHTML={{ __html: description ?? '' }}></div>
      </div>
    </div>
  )
}

export default PageTermCondition;
